export default class DisciplineSubCode {
  disciplineSubCodeId?: number | null;
  code?: string | null;
  name?: string | null;
  disciplineId?: number | null;

  public constructor(params: DisciplineSubCode = {} as DisciplineSubCode) {
    let {
      disciplineSubCodeId = 0,
      code = "",
      name = "",
      disciplineId = null,
    } = params;
    this.disciplineSubCodeId = disciplineSubCodeId;
    this.code = code;
    this.name = name;
    this.disciplineId = disciplineId;
  }
}
